import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SessionService } from './session.service';
import {
  TournamentRegistrationResponse,
  TournamentRegistrationsResponse
} from './tournament-registrations-api.types';

@Injectable({ providedIn: 'root' })
export class TournamentRegistrationsApiService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SessionService);
  private readonly apiBaseUrl = environment.apiBaseUrl;

  listForTournament(slug: string): Observable<TournamentRegistrationsResponse> {
    return this.http.get<TournamentRegistrationsResponse>(`${this.apiBaseUrl}/api/tournaments/${slug}/registrations`, {
      headers: this.authHeaders()
    });
  }

  create(slug: string, teamId: number): Observable<TournamentRegistrationResponse> {
    return this.http.post<TournamentRegistrationResponse>(
      `${this.apiBaseUrl}/api/tournaments/${slug}/registrations`,
      { registration: { team_id: teamId } },
      { headers: this.authHeaders() }
    );
  }

  cancel(slug: string, registrationId: number): Observable<TournamentRegistrationResponse> {
    return this.http.post<TournamentRegistrationResponse>(
      `${this.apiBaseUrl}/api/tournaments/${slug}/registrations/${registrationId}/cancel`,
      {},
      { headers: this.authHeaders() }
    );
  }

  checkIn(slug: string, registrationId: number): Observable<TournamentRegistrationResponse> {
    return this.http.post<TournamentRegistrationResponse>(
      `${this.apiBaseUrl}/api/tournaments/${slug}/registrations/${registrationId}/check-in`,
      {},
      { headers: this.authHeaders() }
    );
  }

  private authHeaders(): HttpHeaders {
    const token = this.session.token();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
